<ng-container [formGroup]="form">
  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">Request Analytics</h5>
  </div>
  <div class="modal-body" ngbAutofocus>
    <ng-container *ngIf="!(loading$ | async) && !cloudRiskError">
      <div class="form-row">
        <div class="form-group col-6 source">
          <app-dc-select
            formControlName="requestType"
            [labelId]="'source'"
            label="Select source"
            [items]="productType | filterSource: source : requestTypeValue?.value"
            closeOnSelect="true"
          >
          </app-dc-select>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-6 source" *ngIf="asof.enabled">
          <app-dc-date-input
            label="As Of Date"
            [id]="'asof'"
            placeholder=""
            formControlName="asof"
            container="body"
          ></app-dc-date-input>
        </div>
        <div class="form-group col-6 source" *ngIf="fairValue.enabled">
          <app-dc-input-number-percent
            label="Fair Value"
            [id]="'fairValue'"
            type="text"
            formControlName="fairValue"
            [lockDefault]="true"
            mask="separator"
            thousandSeparator=","
            defaultUnit="pct"
          ></app-dc-input-number-percent>
        </div>
        <ng-container *ngIf="this.requestTypeValue.value !== 'cloudRiskStress' && this.requestTypeValue.value !== 'fvc'">
          <div class="form-group col-6 source" *ngIf="hurdleRate?.enabled">
            <app-dc-input-number-percent
              label="Hurdle Rate"
              [id]="'hurdleRate'"
              type="text"
              formControlName="hurdleRate"
              [lockDefault]="true"
              mask="separator"
              thousandSeparator=","
              defaultUnit="pct"
              [allowNegativeNumbers]="true"
            ></app-dc-input-number-percent>
          </div>
          <div class="form-group col-6 source" *ngIf="spread?.enabled">
            <app-dc-input-number-percent
              label="Spread"
              [id]="'spread'"
              type="text"
              formControlName="spread"
              [lockDefault]="true"
              mask="separator"
              [allowNegativeNumbers]="true"
              thousandSeparator=","
              defaultUnit="pct"
            ></app-dc-input-number-percent>
          </div>
        </ng-container>
      </div>
      <ng-container *ngIf="this.requestTypeValue.value === 'cloudRiskStress' || this.requestTypeValue.value === 'fvc'">
        <div class="form-row">
          <div class="form-group col-lg-6">
            <app-dc-select
              [labelId]="'benchmarkMode'"
              [label]="'Benchmark Type'"
              [items]="BENCHMARK_TYPES"
              closeOnSelect="true"
              formControlName="benchmarkMode"
              [readonly]="true"
            ></app-dc-select>
          </div>
          <div class="form-group col-6" *ngIf="benchmarkMode?.value === true">
            <app-dc-input-number-percent
              label="Hurdle Rate"
              [id]="'hurdleRate'"
              type="text"
              formControlName="hurdleRate"
              [lockDefault]="true"
              mask="separator"
              thousandSeparator=","
              defaultUnit="pct"
              [allowNegativeNumbers]="true"
              [readonly]="true"
              [loading]="defaultHurdleOrSpreadLoading"
            ></app-dc-input-number-percent>
          </div>
          <div class="form-group col-6" *ngIf="benchmarkMode?.value === false">
            <app-dc-input-number-percent
              label="Spread"
              [id]="'spread'"
              type="text"
              formControlName="spread"
              [lockDefault]="true"
              mask="separator"
              [allowNegativeNumbers]="true"
              thousandSeparator=","
              defaultUnit="pct"
              [readonly]="true"
              [loading]="defaultHurdleOrSpreadLoading"
            ></app-dc-input-number-percent>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <app-dc-loading *ngIf="loading$ | async"></app-dc-loading>
    <ng-container *ngIf="cloudRiskError">
      <h5>
        The following errors happened when trying to load CloudRisk Analytics
      </h5>
      <app-dc-table
        #table
        [columns]="cloudRiskColumns"
        [rows]="cloudRiskError"
        [messages]="messages"
      ></app-dc-table>
    </ng-container>
  </div>
  <div class="modal-footer justify-content-right">
    <button type="button" class="btn btn-secondary btn-sm" (click)="cancel()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary btn-sm"
      [disabled]="form.invalid || (loading$ | async)"
      (click)="save()"
    >
      {{ cloudRiskError ? "Retry" : "Request" }}
    </button>
  </div>
</ng-container>
<ng-template
  #locationTempRef
  ngx-datatable-cell-template
  let-row="row"
  let-value="value"
>
  {{ value?.join(" > ") }}
</ng-template>
<ng-template
  #typeTempRef
  ngx-datatable-cell-template
  let-row="row"
  let-value="value"
>
  <span class="capitalize">
    {{ value }}
  </span>
</ng-template>
